export default __webpack_public_path__ + "static/media/bg-7.4ccabc12.png";